export default {
  CREATE_DOCUMENT: {
    url: '/e-certificate/eCertificate',
    isPublic: false,
    method: 'POST'
  }
}
